import { useContext } from "react";
import HotkeysContext from "contexts/HotkeysContext";
const useHotkeysContext = () => useContext(HotkeysContext);
export default useHotkeysContext;
